import styled from "styled-components";

export const Progress = styled.div`
  margin-bottom: 8px;
  position: relative;
  border-radius: var(--rounding-radius-xxs, 4px);
  background: var(--fill-secondary, rgba(204, 187, 184, 0.16));
  height: 8px;
`;

export const Painted = styled.div`
  border-radius: var(--rounding-radius-xxs, 4px);
  background: var(--fill-primary, #9fe);
  position: absolute;
  left: 0;
  top: 0;
  width: 30%;
  height: 100%;
`;

export const Description = styled.div`
  display: flex;
  justify-content: space-between;
`;
